<template>
    <div>
        <el-card class="box-card">
            <el-form :model="speedForm" ref="speedFormRef" label-width="70px">
                <el-form-item label="speed0" class="addAdminForm">
                    <el-input v-model="speedForm.speed0" placeholder="请输入档位"></el-input>
                </el-form-item>
                <el-form-item label="speed1" class="addAdminForm">
                    <el-input v-model="speedForm.speed1" placeholder="请输入档位"></el-input>
                </el-form-item>
                <el-form-item label="speed2" class="addAdminForm">
                    <el-input v-model="speedForm.speed2" placeholder="请输入档位"></el-input>
                </el-form-item>
                <el-form-item label="speed3" class="addAdminForm">
                    <el-input v-model="speedForm.speed3" placeholder="请输入档位"></el-input>
                </el-form-item>
                <el-form-item label="speed4" class="addAdminForm">
                    <el-input v-model="speedForm.speed4" placeholder="请输入档位"></el-input>
                </el-form-item>
                <el-form-item label="speed5" class="addAdminForm">
                    <el-input v-model="speedForm.speed5" placeholder="请输入档位"></el-input>
                </el-form-item>
                <el-form-item label="speed6" class="addAdminForm">
                    <el-input v-model="speedForm.speed6" placeholder="请输入档位"></el-input>
                </el-form-item>
                <el-form-item label="speed7" class="addAdminForm">
                    <el-input v-model="speedForm.speed7" placeholder="请输入档位"></el-input>
                </el-form-item>
                <el-form-item label="speed8" class="addAdminForm">
                    <el-input v-model="speedForm.speed8" placeholder="请输入档位"></el-input>
                </el-form-item>
                <el-form-item label="speed9" class="addAdminForm">
                    <el-input v-model="speedForm.speed9" placeholder="请输入档位"></el-input>
                </el-form-item>
                <el-form-item label="speed10" class="addAdminForm">
                    <el-input v-model="speedForm.speed10" placeholder="请输入档位"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="apieditspeed">保存</el-button>
                    <el-button type="info" @click="backSpeed">返回</el-button>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      speedForm: {
        speedid: '',
        speed0: '',
        speed1: '',
        speed2: '',
        speed3: '',
        speed4: '',
        speed5: '',
        speed6: '',
        speed7: '',
        speed8: '',
        speed9: '',
        speed10: ''
      },
      parentdata: null
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata

      this.speedForm.speedid = localStorage.getItem('Speedid')
      this.speedForm.speed0 = localStorage.getItem('Speed0')
      this.speedForm.speed1 = localStorage.getItem('Speed1')
      this.speedForm.speed2 = localStorage.getItem('Speed2')
      this.speedForm.speed3 = localStorage.getItem('Speed3')
      this.speedForm.speed4 = localStorage.getItem('Speed4')
      this.speedForm.speed5 = localStorage.getItem('Speed5')
      this.speedForm.speed6 = localStorage.getItem('Speed6')
      this.speedForm.speed7 = localStorage.getItem('Speed7')
      this.speedForm.speed8 = localStorage.getItem('Speed8')
      this.speedForm.speed9 = localStorage.getItem('Speed9')
      this.speedForm.speed10 = localStorage.getItem('Speed10')
    },
    backSpeed () {
      this.$emit('triggerFunc', '')
    },
    apieditspeed: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        speedid: this.speedForm.speedid,
        speed0: this.speedForm.speed0,
        speed1: this.speedForm.speed1,
        speed2: this.speedForm.speed2,
        speed3: this.speedForm.speed3,
        speed4: this.speedForm.speed4,
        speed5: this.speedForm.speed5,
        speed6: this.speedForm.speed6,
        speed7: this.speedForm.speed7,
        speed8: this.speedForm.speed8,
        speed9: this.speedForm.speed9,
        speed10: this.speedForm.speed10
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editspeed, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.backSpeed()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>
<style lang="less" scoped>

</style>
